import { useQuery } from '@tanstack/react-query';
import { StatusCode } from '@hungryroot/rest';
import { getCancelSubreasons } from '@hungryroot/rest/api/get_cancel_subreasons/get';

export function useCancelSubreasons(data: { cancelReason: number }) {
  return useQuery({
    queryKey: ['cancel_subreasons'],
    queryFn: async () => {
      const resp = await getCancelSubreasons(data);

      if (resp.status !== StatusCode.SuccessOK) {
        throw new Error(JSON.stringify(resp.data, null, 2));
      }

      return resp.data;
    },
  });
}
